import types from './types'
import api from '@/api'

export default {
  state: {
    user: null
  },
  getters: {
    user (state) {
      return state.user
    }
  },
  actions: {
    /**
         * @description 拉取当前用户
         * @author yangyu
         */
    [types.GET_USER] ({commit}) {
      return api('common/getCurrentUser')().then(user => {
        return commit(types.SET_USER, user)
      })
    },
    /**
         * @description 登录 / 绑定
         * @author yangyu
         */
    [types.LOGIN] ({commit}, params) {
      return api('common/login', params)().then(user => {
        commit(types.SET_USER, user)
      })
    },
    /**
     * @description 设置用户
     * @author yangyu
     */
    [types.SET_USER] ({commit}, user) {
      return commit(types.SET_USER, user)
    },
    /**
     * @description 注销用户登录
     * @author lixian
     */
    [types.LOGOUT] () {
      return api('common/logout')()
    },
    /**
     * @description 获取授权地址
     * @author lixian
     */
    [types.AUTH_URL] ({commit}, params) {
      return api('common/getAuthUrl', params)()
    }
  },
  mutations: {
    [types.SET_USER] (state, user) {
      state.user = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/index.js